export default __webpack_public_path__ + "static/media/attendance-confirmation.553e2f45.svg";